import * as React from 'react';
import type { SVGProps } from 'react';
const SvgSupportCenter = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns='http://www.w3.org/2000/svg' width={24} height={24} fill='none' {...props}>
    <path
      stroke='currentColor'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth={1.5}
      d='M3 12.992v-2a9 9 0 1 1 18 0v2M21 12.992v1.637c0 1.952-.738 3.826-2.05 5.206-1.313 1.381-3.093 2.157-4.95 2.157'
    />
    <path
      stroke='currentColor'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth={1.5}
      d='M21 14.992a2 2 0 0 1-2 2h-1a2 2 0 0 1-2-2v-3a2 2 0 0 1 2-2h3zm-18 0a2 2 0 0 0 2 2h1a2 2 0 0 0 2-2v-3a2 2 0 0 0-2-2H3zM11.143 21.992c-.303 0-.594-.126-.808-.351a1.23 1.23 0 0 1-.335-.849v-.6c0-.318.12-.623.335-.848.214-.225.505-.352.808-.352h1.714c.303 0 .594.127.808.352s.335.53.335.848v1.8z'
    />
  </svg>
);
export default SvgSupportCenter;
